import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { List, ListItemIcon, ListItemText, Skeleton } from '@mui/material';
import PropTypes from 'prop-types';
import { VersionsListItemButton } from './styles';
const VersionsList = ({ disabled, loading, versions, selectedVersionId, onSelectContractVersion: onSelectVersion, VersionListItemComponent, }) => {
    return (_jsxs(List, { children: [loading &&
                Array.from({ length: 6 }).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                _jsx(VersionsListItemSkeleton, {}, index))), !loading &&
                versions.map((version) => (_jsx(VersionListItemComponent, { disabled: disabled, version: version, selected: version.Id === selectedVersionId, onSelect: onSelectVersion }, version.Id)))] }));
};
VersionsList.defaultProps = {
    disabled: false,
    loading: false,
};
VersionsList.propTypes = {
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    versions: PropTypes.arrayOf(PropTypes.shape({
        Id: PropTypes.number.isRequired,
    }).isRequired).isRequired,
    selectedVersionId: PropTypes.number,
    onSelectContractVersion: PropTypes.func.isRequired,
    VersionListItemComponent: PropTypes.elementType.isRequired,
};
const VersionsListItemSkeleton = () => {
    return (_jsxs(VersionsListItemButton, { children: [_jsx(ListItemIcon, { children: _jsx(Skeleton, { variant: 'circular', width: 20, height: 20 }) }), _jsx(ListItemText, { primary: _jsx(Skeleton, { variant: 'text', width: 180 }), secondary: _jsx(Skeleton, { variant: 'text', width: 80 }) })] }));
};
export default VersionsList;
export { VersionsListItemButton };
